import React, { useEffect, useState } from 'react';
import { BASE_URL } from '../config/api'; // Ensure BASE_URL is correctly defined
import { useNavigate } from 'react-router-dom';
import jsPDF from 'jspdf'; // Import jsPDF
import 'jspdf-autotable'; // Import for table support
import * as XLSX from 'xlsx'; // Import xlsx for Excel export

const CategoriesList = () => {
    const [categories, setCategories] = useState([]);
    const [filteredCategories, setFilteredCategories] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        fetch(`${BASE_URL}categories`)
            .then(response => response.json())
            .then(data => {
                if (data.status === 1) {
                    setCategories(data.data);
                    setFilteredCategories(data.data);
                } else {
                    alert('Failed to fetch categories');
                }
            })
            .catch(error => console.error('Error fetching categories:', error));
    }, []);

    const handleSearchChange = (event) => {
        const term = event.target.value;
        setSearchTerm(term);
        const filtered = categories.filter(category =>
            category.name.toLowerCase().includes(term.toLowerCase())
        );
        setFilteredCategories(filtered);
    };

    const handleEdit = (id) => {
        navigate(`/EditCategory/${id}`);
    };

    const handleAdd = () => {
        navigate('/AddCategories');
    };

    const handleDelete = (id) => {
        if (window.confirm("Are you sure you want to delete this category?")) {
            fetch(`${BASE_URL}categories/${id}`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then(response => response.json())
                .then(data => {
                    if (data.status === 1) {
                        setCategories(categories.filter(category => category.id !== id));
                        setFilteredCategories(filteredCategories.filter(category => category.id !== id));
                    }
                })
                .catch(error => console.error('Error deleting category:', error));
        }
    };

    // Export filteredCategories to PDF
    const handleExportPDF = () => {
        const doc = new jsPDF();
        doc.text('Categories List', 14, 10); // Add a title to the PDF

        // Map data for the table
        const tableData = filteredCategories.map(category => [
            category.id,
            category.name || 'N/A',
            category.image ? `${BASE_URL}${category.image}` : 'No Image',
        ]);

        // Add table to the PDF
        doc.autoTable({
            head: [['ID', 'Name', 'Image URL']], // Table headers
            body: tableData,
        });

        // Save the PDF
        doc.save('categories-list.pdf');
    };

    // Export filteredCategories to Excel
    const handleExportExcel = () => {
        const worksheet = XLSX.utils.json_to_sheet(filteredCategories.map(category => ({
            ID: category.id,
            Name: category.name || 'N/A',
            Image: category.image ? `${BASE_URL}${category.image}` : 'No Image',
        })));

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Categories List");

        // Save the Excel file with a filename
        XLSX.writeFile(workbook, 'categories-list.xlsx');
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Category List</h3>
                        </div>
                        <div className="col-12 col-md-6 order-md-2 order-first">
                            <nav aria-label="breadcrumb" className="breadcrumb-header float-start float-lg-end">
                                <ol className="breadcrumb"></ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            <section className="section">
                <div className="row" id="basic-table">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <div className="row">
                                    <div className="col-md-6">
                                        <label htmlFor="searchTerm" className="form-label">Search by Name</label>
                                        <input
                                            type="text"
                                            id="searchTerm"
                                            className="form-control"
                                            placeholder="Search category name"
                                            value={searchTerm}
                                            onChange={handleSearchChange}
                                        />
                                    </div>
                                    <div className="col-md-6 text-end">
                                        <button className="btn btn-primary me-2" onClick={handleAdd}>Add Category</button>
                                        <button className="btn btn-secondary me-2" onClick={handleExportPDF}>Export to PDF</button>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="table-responsive">
                                    <table className="table table-lg">
                                        <thead>
                                            <tr>
                                                <th>ID</th>
                                                <th>NAME</th>
                                                <th>IMAGE</th>
                                                <th className="text-end">ACTION</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredCategories.map(category => (
                                                <tr key={category.id}>
                                                    <td>{category.id}</td>
                                                    <td>{category.name || 'N/A'}</td>
                                                    <td>
                                                        {category.image ? (
                                                            <img
                                                                src={`http://pbhrm.com/${category.image}`}
                                                                alt={category.name}
                                                                style={{ width: '100px', height: 'auto' }}
                                                            />
                                                        ) : (
                                                            'No Image'
                                                        )}
                                                    </td>
                                                    <td className="text-end">
                                                        <button className="btn btn-success" onClick={() => handleEdit(category.id)}>Edit</button>
                                                        <button className="btn btn-danger ms-2" onClick={() => handleDelete(category.id)}>Delete</button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default CategoriesList;
